import { Injectable } from '@angular/core';
import { ObjectCacheService } from './icache-service';
import { ParamMap } from '../data-service/system-param-cache-define';
import { ParameterApi } from '../api-service/parameters/parameter-api';
import { EasyNotificationService } from '../easy-notification.service';
import { GpParaApi } from '../api-service/gp-para/gp-para-api';

@Injectable({
  providedIn: 'root'
})

/**
 * P參數快取Service Key為p編號
 * @implements {ICacheService<ParamType, Map<ParamType, any>>}
 */
export class GPParameterCachedService extends ObjectCacheService<GPPObject> {

  protected notifyMsgOnUpdated: string = 'P參數已變更…';
  protected notifyMsgOnReload: string = '已重載P參數'
  /**
   * 建構子，初始化服務。
   * @param {ParameterApi} parameterApi - 用於獲取參數的 API 服務。
   * @param {EasyNotificationService} notifyService - 用於顯示通知的服務。
   */
  constructor(private gppApi: GpParaApi, private notifyService: EasyNotificationService) {
    super(notifyService);
  }

  protected async getCacheObject<K extends keyof GPPObject>(keys: K[]): Promise<Map<K, GPPObject[K]>> {
    var m = new Map();
    var o = await this.gppApi.Get();
    
    for (let ind =0; ind<o.length;ind++) {
      // 快取Key存的是編號
      m.set((ind+1).toString(), o[ind]);
    }
    return m;
  }
}
declare type GPPObject = {[key:string]:string}
